"use strict";

var _regeneratorRuntime = require("/Users/robo/gitLab/uav-monitoring/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/robo/gitLab/uav-monitoring/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _slicedToArray = require("/Users/robo/gitLab/uav-monitoring/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useWebPSupportCheck = void 0;

var react_1 = require("react");

var supports_webp_1 = __importDefault(require("supports-webp"));

function useWebPSupportCheck() {
  var _react_1$useState = react_1.useState({
    webP: false
  }),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      supportsWebP = _react_1$useState2[0].webP,
      setWebPSupport = _react_1$useState2[1];

  react_1.useEffect(function () {
    // eslint-disable-next-line unicorn/consistent-function-scoping
    var checkForSupport = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var browserSupportsWebP;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return supports_webp_1.default;

              case 2:
                browserSupportsWebP = _context.sent;
                setWebPSupport({
                  webP: browserSupportsWebP
                });

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function checkForSupport() {
        return _ref.apply(this, arguments);
      };
    }();

    checkForSupport();
  }, [supports_webp_1.default]);
  return supportsWebP;
}

exports.useWebPSupportCheck = useWebPSupportCheck;